import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-099305d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col pageDetail" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "detailTitle" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailType" }, "领取方式", -1))
const _hoisted_6 = { class: "detailContent" }
const _hoisted_7 = { class: "fixBtn" }
const _hoisted_8 = { class: "btn_time" }
const _hoisted_9 = {
  key: 0,
  class: "btn btn_gray"
}
const _hoisted_10 = {
  key: 2,
  class: "btn btn_gray"
}
const _hoisted_11 = {
  key: 3,
  class: "btn btn_gray"
}
const _hoisted_12 = {
  key: 4,
  class: "btn btn_gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.detailDatas.goodsImg,
      class: "detailTop"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detailDatas.goodsName), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.detailDatas.receiveMethod), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, "今日 " + _toDisplayString(_ctx.detailDatas.timePoint) + "开抢", 1),
      (_ctx.detailDatas.dhStatus==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "即将开抢"))
        : (_ctx.detailDatas.dhStatus==1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "btn btn_red",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getSecKillKill && _ctx.getSecKillKill(...args)))
            }, "立即抢购"))
          : (_ctx.detailDatas.dhStatus==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "已抢完"))
            : (_ctx.detailDatas.dhStatus==3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "会员已抢购"))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, "不可重复抢购"))
    ])
  ]))
}